import * as React from "react";
import { useTranslation } from "react-i18next";
import { NoEntitiesExist, PaginatedList } from "components/common";
import { Col, Row } from "common/components/layout-styles";
import { usePagination, ModalProvider, SelectedRowsProvider } from "common/contexts";
import AlertsModals from "security-app/components/SecurityEvents/Alerts/AlertsModals";
import BulkActions from "./BulkActions";
import EventList from "./EventList";
import { NoEntitiesExistWrapper } from "../shared";
function SecurityEvents({
  securityEvents = [],
  pagination = { total: 10, page: 1, perPage: 10, count: 10 },
  onPageChange = (_newPage, _newPerPage) => {
  },
  onEventSelect
}) {
  const { t } = useTranslation("enterprise_security_assets");
  const localPagination = usePagination();
  if (securityEvents.length === 0) {
    return /* @__PURE__ */ React.createElement(NoEntitiesExistWrapper, null, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, t("security_events.no_security_events")));
  }
  return /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(Row, { $align: "stretch" }, /* @__PURE__ */ React.createElement(Col, { $align: "center" }, /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      activePage: localPagination.page,
      pageSize: localPagination.perPage,
      onChange: onPageChange,
      totalItems: pagination == null ? void 0 : pagination.total,
      useQueryParameter: false,
      showPageSizeSelect: false
    },
    /* @__PURE__ */ React.createElement(Row, { $width: "100%" }, /* @__PURE__ */ React.createElement(BulkActions, { secEvents: securityEvents })),
    /* @__PURE__ */ React.createElement(EventList, { securityEvents, onEventSelect })
  ))), /* @__PURE__ */ React.createElement(AlertsModals, null)));
}
export default SecurityEvents;
